// src/chat/adminSupportChatApi.ts
import { apiClient } from "@maat/api-base";
var adminSupportChatApi = {
  /** Unread counts per support thread, for merging into the ticket queue. */
  getUnreadCounts: async () => {
    return apiClient.get("/chat/api/admin/support/unread");
  },
  /**
   * Resolve a ticket's thread. The console reads `conversation_id` off the
   * ticket normally; this covers the window before that link is stamped.
   */
  getConversationByTicket: async (ticketId) => {
    return apiClient.get(`/chat/api/admin/support/conversations/by-ticket/${ticketId}`);
  },
  /**
   * One enriched thread. The console arrives from the ticket queue, so it has
   * no conversation list to read the row off — and the components it renders
   * need the real `current_user_context`/`guest_id` to decide message sides.
   */
  getConversation: async (conversationId) => {
    return apiClient.get(`/chat/api/admin/support/conversations/${conversationId}`);
  },
  getMessages: async (conversationId, params) => {
    return apiClient.get(`/chat/api/admin/support/conversations/${conversationId}/messages`, {
      params
    });
  },
  sendMessage: async (conversationId, data) => {
    return apiClient.post(
      `/chat/api/admin/support/conversations/${conversationId}/messages`,
      data
    );
  },
  /** Mirrors `chatApi.sendMessageAttachments` — same multipart contract, same
   *  controller, admin path. Operators send screenshots back to customers. */
  sendMessageAttachments: async (conversationId, { files, text, durations }) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    if (text?.trim()) formData.append("text", text.trim());
    if (durations?.some((d) => Number.isFinite(d))) {
      formData.append(
        "meta",
        JSON.stringify(files.map((_, i) => ({ duration_seconds: durations[i] })))
      );
    }
    return apiClient.post(
      `/chat/api/admin/support/conversations/${conversationId}/messages/attachments`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  },
  markRead: async (conversationId, data) => {
    return apiClient.post(`/chat/api/admin/support/conversations/${conversationId}/read`, data);
  },
  getInternalNotes: async (conversationId, params) => {
    return apiClient.get(`/chat/api/admin/support/conversations/${conversationId}/notes`, {
      params
    });
  },
  createInternalNote: async (conversationId, data) => {
    return apiClient.post(
      `/chat/api/admin/support/conversations/${conversationId}/notes`,
      data
    );
  },
  summarize: async (conversationId) => {
    return apiClient.get(`/chat/api/admin/support/conversations/${conversationId}/summarize`);
  },
  /**
   * Relative, like the consumer stream — EventSource resolves it against the
   * page origin, so one build works locally (Vite proxy) and behind nginx.
   */
  getSSEUrl: () => {
    return "/chat/api/admin/sse";
  }
};

export {
  adminSupportChatApi
};
